import isNil from "lodash/fp/isNil";

class Controller {
  constructor($mdDialog, Events, Captain, ride) {
    "ngInject";

    this.ride = ride;
    this.ride.captain = this.ride.captain || {}; // Fallback for rides that don't have a captain key in their object
    this.hasCaptain = !isNil(ride.captain._id);
    this.$mdDialog = $mdDialog;
    this.Events = Events;
    this.Captain = Captain;

    this.getBusesEvent = this.Events.getUpdateEvent("assignedBus");
    this.errorNotificationEvent = this.Events.eventsType.onShowErrorNotification;

    this.busTypeParams = {
      city: this.ride.city.value,
      captain: this.ride.captain._id,
    };
  }

  $onInit() {
    this.Events.on(this.getBusesEvent, this.getBuses.bind(this));

    this.bus_type = { ...this.ride.bus_type };

    this.initGetBuses();
  }

  initGetBuses() {
    const { bus_type: busType } = this.ride;
    if (!isNil(busType) && !isNil(busType._id)) {
      this.getBuses(busType);
    }
  }

  getBuses({ _id }) {
    const { _id: captainId } = this.ride.captain;
    const items = {
      bus_type: _id,
      isCityRequired: false,
    };

    this.Captain.assignedBuses(captainId, items).$promise.then(
      (response) => {
        this.buses = response.buses;
        this.bus = this.buses.find((bus) => bus._id === this.ride.bus._id);
      },
      (response) => this.Events.emit(this.errorNotificationEvent, response.data)
    );
  }

  close() {
    this.$mdDialog.cancel();
  }

  confirm() {
    const { _id: busType } = this.bus_type;
    const { _id: bus } = this.bus;

    this.$mdDialog.hide({ bus_type: busType, bus });
  }
}

export default Controller;



// WEBPACK FOOTER //
// ./src/pages/ride/assignBusDialog/assignBusDialog.controller.js